import { config } from '../../Config';

const GetAllChatsFromCosmos = async (userId) => {
    const url = config.getAllChats;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId })
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch chats from Cosmos DB: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        // console.error('Error fetching chats from Cosmos DB:', error);
        return [];
    }
};

export default GetAllChatsFromCosmos;
